/**
 * @ngdoc module
 * @name flowingly.runner.print
 */
const m = angular.module('flowingly.runner.print', []);
m.run([
  '$templateCache',
  function ($templateCache) {
    $templateCache.put(
      'Client/runner.print/runner.print.flowmodelschema.tmpl.html',
      require('./runner.print.flowmodelschema.tmpl.html').default
    );
  }
]);
